export const MY_FAVORITES_TITLE = 'My Favorites';
